import {SizeSelection_Size} from '@aboutyou/grpc-clients/tadarida/aysa_api/models/size_selection.types';
import {useEffect, useState} from 'react';
import {useProductIdFromSlug} from '../../ProductUrl';

export interface SizeSource {
  sizeSource?: 'shop' | 'vendor';
}
export type SelectedSize = SizeSelection_Size | undefined;
export type SetSelectedSize = (size: SelectedSize) => void;

export const useSelectedSizeState = (
  defaultSelectedSize?: SizeSelection_Size,
  providedProductId?: number,
): {
  selectedSize: SelectedSize;
  setSelectedSize: SetSelectedSize;
} => {
  const productIdFromSlug = useProductIdFromSlug();
  const productId = providedProductId ?? productIdFromSlug;
  const [selectedSize, setSelectedSize] = useState<
    SizeSelection_Size | undefined
  >(defaultSelectedSize);

  useEffect(() => {
    // eslint-disable-next-line local-rules/set-state-in-use-effect -- TODO: Cleanup setState in useEffect https://aboutyou.atlassian.net/browse/ASFE-7602
    setSelectedSize(defaultSelectedSize);
  }, [productId, defaultSelectedSize]);

  return {
    selectedSize,
    setSelectedSize,
  };
};
